import { render, staticRenderFns } from "./RegisterOrg.vue?vue&type=template&id=10bd7a5f&scoped=true"
import script from "./RegisterOrg.vue?vue&type=script&lang=js"
export * from "./RegisterOrg.vue?vue&type=script&lang=js"
import style0 from "./RegisterOrg.vue?vue&type=style&index=0&id=10bd7a5f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bd7a5f",
  null
  
)

export default component.exports